module.exports = __webpack_public_path__ + "media/application/images/friends-18b85da06465b579fd3e22f14669c788.png";